// extracted by mini-css-extract-plugin
export default {"container":"yp-z","heading":"zp-z","text":"Ap-z","info":"Bp-z","link":"Cp-z","fullMaxWidth":"Dp-z"};